import CloseSave from "../design/close";
import "./insertMassage.css";

export default ({setClose, data}) => {

    return (
        <div className="insert-massage-admin-aufa">
            <div>
                <p>עדכון קבצים</p>
                <CloseSave setClose={setClose} bc="white" c="gray" />
            </div>

            {
                (typeof data === 'object' && data !== null) ? 

                <div>
                    { 
                        Object.keys(data).map((value, key) => <>
                            <p key={key + (key * 3)}> {key + 1} </p>
                            <p key={key + (key * 3)}> {value} </p>
                            <p key={key + (key * 3)} style={{color: data[value] != 'success' ? 'red' : 'gray'}}> {data[value]} </p>
                        </>)
                    }
                </div> 
                :
                <p>שגיאה באחד מהנתונים</p>
            }

        </div>
    )
}